// from https://alligator.io/vuejs/global-event-bus/
import Vue from 'vue';
export const EventBus = new Vue();